import React from 'react';
import "./../css/Historia.css"
import Collage from './../img/Historia/collage.png'

function Historia() {
    return (
      <section className='historia'>
        <article className='historia__texto'>
            <p className='historia__texto__nuestra'>
                Nuestra Historia
            </p>
            <h1 className='historia__texto__titulo'>
                Heladería desde 1962
            </h1>
            <p className='historia__texto__contenido'>
                Cuando en el año 1962 la familia Toscani abría su primera Heladería inspirada en las tradiciones familiares de las heladerías artesanales italianas, la emblemática esquina de Arocena Y Schroeder se convirtió rápidamente en un referente del centro comercial de Carrasco. Hace 58 años se inició el sueño de una familia de inmigrantes y el éxito de una marca que se identificó plenamente con los vecinos residentes de Carrasco y en buena parte de la costa montevideana. Hoy en día seguimos con orgullo dicha tradición esforzándonos día a día para seguir brindado calidad y buen servicio a nuestros clientes.
            </p>
        </article>
        <div className='historia__img'>
           <img  className='historia__img__img' src={Collage}/> 
        </div>
        
      </section>
    );
  }
  
  export default Historia;